export const PRESET_RANGES = [
  { label: "£0–£20", min: 0, max: 20 },
  { label: "£20–£35", min: 20, max: 35 },
  { label: "£35–£50", min: 35, max: 50 },
  { label: "£50+", min: 50, max: null },
];

export const SORT_OPTIONS = [
  { value: "newest", label: "Newest" },
  { value: "oldest", label: "Oldest" },
  { value: "price_asc", label: "Price: Low to high" },
  { value: "price_desc", label: "Price: High to low" },
  { value: "name_asc", label: "Name: A to Z" },
  { value: "name_desc", label: "Name: Z to A" },
];

export const FACETS = [
  { key: "brands", label: "Brand" },
  { key: "colors", label: "Colour" },
  { key: "materials", label: "Material" },
  { key: "sizes", label: "Size" },
  { key: "patterns", label: "Pattern" },
];
